<template>
  <div id="wrap">
    <!-- 본문 영역 시작-->

    <!-- 본문 영역 끝-->
  </div>
</template>
<script>
import TermsPersonal from "../terms/nice/TermsPersonal";
import TermsServiceSubscribe from "../terms/nice/TermsServiceSubscribe";
import TermsTelecom from "../terms/nice/TermsTelecom";
import TermsUniqueIdInformation from "../terms/nice/TermsUniqueIdInformation";
import { delay } from "q";

export default {
  name: "app",

  data: () => ({
    valid: false,
    recaptchaVerify: false,
    recaptchaVerifyCheck: true,
    type: "idVerify",
    teleCoCd: "3", //통신사구분코드
    name: "", // 이름
    birth: "", // 생년월일
    genCd: "M", // 성별코드
    cellTelNo: "", // 전화번호
    prdtNo: "A002",
    progressDialog: false,
    foreignerChk: true,
    chk_all: false,
    chk_a1: false,
    chk_a2: false,
    chk_a3: false,
    chk_a4: false,
    dialog_a1: false,
    dialog_a2: false,
    dialog_a3: false,
    dialog_a4: false,
    adtDialog: false,
    rules: {
      nameRules: [(v) => !!v || "이름을 입력하세요."],
      birthRules: [(v) => !!v || "생년월일을 입력하세요.", (v) => (v && v.length >= 8 && /((1|2)[0-9]{3})(0[1-9]{1}|1[0-2]{1})(0[1-9]|(1|2)[0-9]{1}|3[0-1]{1})$/.test(v)) || "생년월일이 정확하지 않습니다."]
    }
  }),
  computed: {
    form() {
      return {
        name: this.name,
        birth: this.birth,
        cellTelNo: this.cellTelNo,
        genCd: this.genCd,
        foreignerChk: this.foreignerChk
      };
    }
  },
  components: {
    TermsPersonal,
    TermsServiceSubscribe,
    TermsTelecom,
    TermsUniqueIdInformation
  },
  created() {
    // console.log("router", this.$router.name);
    // console.log("$route", this.$route.params);
    this.type = this.$route.params.type;
    this.teleCoCd = this.$route.params.teleCoCd;
    this.cellTelNo = this.$route.params.cellTelNo;
    this.mvnoYn = this.$route.params.mvnoYn;

    if (this.type == undefined) {
      this.returnDialog = true;
    }
  },
  methods: {
    checkAll() {
      this.chk_a1 = this.chk_all;
      this.chk_a2 = this.chk_all;
      this.chk_a3 = this.chk_all;
      this.chk_a4 = this.chk_all;
    },

    checkBoxCheck() {
      if (this.chk_a1 && this.chk_a2 && this.chk_a3 && this.chk_a4) {
        this.chk_all = true;
      } else {
        this.chk_all = false;
      }
    },
    // 미성년자 체크
    adtChek() {
      var adt = 19; // 성년 나이
      var d = new Date();
      var y = d.getFullYear();
      var m = d.getMonth() + 1;
      var d = d.getDate();
      var f = this.birth;

      // 날짜 포맷 맞추기
      if (m < 10) m = "0" + m;
      if (d < 10) d = "0" + d;

      var birthday_y = parseInt(f.substr(0, 4));
      var birthday_m = f.substr(4, 2);
      var birthday_d = f.substr(6, 2);
      var birthday_md = f.substr(4, 4);

      var age = m + d < birthday_md ? y - birthday_y - 1 : y - birthday_y;

      if (age < adt || (age == adt && parseInt("1" + birthday_md) > parseInt("1" + m + d))) {
        return false;
      }
      return true;
    },

    // 본인인증 처리
    submit: function() {
      this.progressDialog = true;
      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();
      if (!this.valid) {
        this.progressDialog = false;
        return false;
      }
      if (!this.recaptchaVerify) {
        this.progressDialog = false;
        return false;
      }
      if (!this.adtChek()) {
        // 미성년자 체크
        this.adtDialog = true;
        this.progressDialog = false;
        return false;
      }
      if (this.teleCoCd == "1") {
        this.prdtNo = "A001";
      } else if (this.teleCoCd == "2") {
        this.prdtNo = "A003";
      } else if (this.teleCoCd == "3") {
        this.prdtNo = "A002";
      }
      this.$router.push({
        name: "passSafeGuardIdVerifyCert", // 본인인증번호 입력 화면 idVerifyCert
        params: {
          // 가입화면에서 받아옴
          type: this.type,
          teleCoCd: this.teleCoCd,
          cellTelNo: this.cellTelNo,
          birth: this.birth,
          genCd: this.genCd,
          name: this.name,
          prdtNo: this.prdtNo,
          foreignerChk: this.foreignerChk
        }
      });
    },
    //vue-recaptcha
    onVerify(r) {
      // console.log(r);
      this.recaptchaVerify = true;
      this.recaptchaVerifyCheck = this.recaptchaVerify;
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },
    exec() {
      this.$refs.recaptcha.execute();
    },
    reset() {
      this.$refs.recaptcha.reset();
    }
  }
};
</script>
<style>
/* validation check color red */
.v-messages__message {
  color: #ff5252 !important;
}
.v-messages__wrapper {
  color: #ff5252 !important;
}
.v-input__control,
.v-input__slot,
.v-select__slot {
  color: #005df9 !important;
}
.mdi-radiobox-marked {
  color: #005df9 !important;
}
/* .v-input--selection-controls__input{
  top: 3px;
}
.v-input__slot {
 top: 2px;
}
.v-radio .v-input--selection-controls__input{
  top: 0px;
} */

.v-input--selection-controls__input {
  margin-right: 3px;
}
.custom-checkbox {
  padding: 0px;
}
.v-input--checkbox {
  margin-top: 0px;
  padding-top: 0px;
}
label {
  margin-bottom: 0px !important;
}
.v-card__text {
  font-size: 14px;
}
.theme--light.v-sheet {
  margin: 0 0;
}
/* label { display: inline-block; width: 20%; } */
.realperson-challenge {
  display: inline-block;
}
/* validation check color red */
.v-messages__message {
  color: #ff5252 !important;
}
.v-input__control,
.v-input__slot,
.v-select__slot {
  color: #005df9 !important;
}
.v-input__slot {
  margin: 3px 0 !important;
}
.custom-checkbox {
  margin-bottom: 0px;
}
.mdi-radiobox-marked {
  color: #005df9 !important;
}
.mdi-checkbox-marked {
  color: #005df9 !important;
}

/* .v-dialog>.v-card>.v-card__subtitle, .v-dialog>.v-card>.v-card__text {
    padding: 0 0px 0px;
} */
</style>
